<p-dialog [header]="header" (onHide)="onHide()" [modal]="true" [(visible)]="isVisible"
  [breakpoints]="{ '5550px': '80vw','575px': '90vw' }" styleClass="border-round-3xl">
  <div class="flex flex-column gap-3">
    @if (!titleTemplate) {
      <span class="sub-title" [innerHTML]="title"></span>
    } @else {
      <ng-template [ngTemplateOutlet]="titleTemplate!"></ng-template>
    }

    @if (titleWithUrl) {
      <span  class="sub-title" tabindex="0" (click)="onTitleUrlAction($event);"
      (keyup)="onTitleUrlAction($event);" [innerHTML]="titleWithUrl"></span>
    }

    @if (subTitle) {
      <span class="sub-title" [innerHTML]="subTitle"></span>
    }
    @if (subTitle2) {
      <span class="sub-sub-title">
        {{subTitle2}}
      </span>
    }
    <div class="flex flex-1 gap-3 justify-content-end">
      @if (buttonLabel2) {
        <p-button [label]="buttonLabel2" [outlined]="true" styleClass="button" (click)="onAction(false);" />
      }
      @if (buttonLabel) {
        <p-button [label]="buttonLabel" styleClass="button" (click)="onAction(true);" />
      }
    </div>
  </div>
</p-dialog>